

import axios from 'axios';
import { Message } from 'element-ui';
import { getCookies, removeCookies } from '@/libs/util';
import Setting from '@/setting';
import router from '@/router';
const service = axios.create({
  baseURL: Setting.apiBaseURL,
  timeout: 10000, // 请求超时时间
});

axios.defaults.withCredentials = true; // 携带cookie

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    config.baseURL = Setting.apiBaseURL;
    if (config.file) {
      config.headers['Content-Type'] = 'multipart/form-data';
    }
    const token = getCookies('token');
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }
	config.headers['Tpl-Version'] = Setting.version
    return config;
  },
  (error) => {
    // do something with request error
    return Promise.reject(error);
  },
);

// response interceptor
service.interceptors.response.use(
  (response) => {
    let obj = {};
    if (!!response.data) {
      if (typeof response.data == 'string') {
        obj = JSON.parse(response.data);
      } else {
        obj = response.data;
      }
    }
    let status = response.data ? obj.status : 0;
    // let status = response.data ? response.data.status : 0;
    const code = status;
    switch (code) {
      case 200:
        return obj;
      case 110002:
      case 110003:
      case 110004:
        localStorage.clear();
        removeCookies('token');
        removeCookies('expires_time');
        removeCookies('uuid');
        router.replace({ name: 'login' });
		return Promise.reject(obj || { msg: '未知错误' });
        break;
	  case 110006:
		const loading1 = Loading.service({
		  lock: true,
		  text: '系统版本变更，正在重载配置...',
		  spinner: 'el-icon-loading',
		  background: 'rgba(0, 0, 0, 0.7)'
		});
		setTimeout(() => {
		  loading1.close();
		  location.reload();
		}, 1000);
		return Promise.reject({ msg: '版本过低' });
	    break;
      // case 110005:
      // case 110006:
      // case 110007:
      //   removeCookies('kefuInfo');
      //   removeCookies('kefu_token');
      //   removeCookies('kefu_expires_time');
      //   removeCookies('kefu_uuid');
      //   router.replace({ path: '/kefu' });
      //   break;
      case 110008:
        router.replace({ name: 'system_opendir_login' });
        break;
      default:
        return Promise.reject(obj || { msg: '未知错误' });
    }
  },
  (error) => {
    Message.error(error.msg);
    return Promise.reject(error);
  },
);

export default service;
